import type { ProfileRecord } from '../types';
import { profilePath } from './navigation';

export interface ProfileVersion {
  version: string;
  releasedAt: string;
  changes: string[];
  fileUrl: string;
  fileName: string;
}

const DEMO_RELEASE_DATE = Date.UTC(2026, 8, 21, 12);
const DAY = 24 * 60 * 60 * 1000;

/** Demo release metadata. Each release uses the existing, unmodified archive binary. */
export function profileVersions(profile: ProfileRecord): ProfileVersion[] {
  const offset = [...profile.creator].reduce((sum, character) => sum + character.charCodeAt(0), 0) % 5;
  const latestDate = Math.max(DEMO_RELEASE_DATE - offset * DAY, Date.parse(profile.updatedAt) + 7 * DAY);
  const release = (version: string, releasedAt: string, changes: string[]): ProfileVersion => ({
    version,
    releasedAt,
    changes,
    fileUrl: profile.fileUrl,
    fileName: `${profile.fileName.replace(/\.rt4$/i, '')} - v${version}.rt4`,
  });
  return [
    release('1.3', new Date(latestDate).toISOString(), ['Adjusted output framing and corrected image cropping.']),
    release('1.2', new Date(latestDate - 2 * DAY).toISOString(), ['Refined sampling phase and horizontal positioning.']),
    release('1.1', new Date(latestDate - 5 * DAY).toISOString(), ['Fine-tuned color levels and mask strength.']),
    release('1.0', profile.uploadedAt, ['Initial profile release.']),
  ];
}

export function profileForVersion(profile: ProfileRecord, release: ProfileVersion): ProfileRecord {
  return { ...profile, updatedAt: release.releasedAt, fileUrl: release.fileUrl, fileName: release.fileName };
}

export function profileVersionPath(profile: ProfileRecord, version: string): string {
  return `${profilePath(profile)}?${new URLSearchParams({ version })}`;
}
